import HistoryItemComponent from '@components/history/historyItem/body/historyItemComponent';
import HistoryItemHeaderComponent from '@components/history/historyItem/header/historyItemHeaderComponent';
import WorkflowItemComponent from '@components/history/workflows/workflowItem/workflowItemComponent';
import Ticket from '@interfaces/qafs/ticket';
import AppContext from '@services/Context';
import { Button, Card, Col, Row } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import I18n from '../../i18n';
import { Theme } from '../../styled-components';

interface IProp {
    data: Ticket[];
    hasMoreWorkflowItens: boolean;
    loadMoreTickets: any
    refreshDataEvent: any
}

type StateType = {
    curTicket?: Ticket,
    loadingMore: boolean
};

class HistoryComponent extends React.Component<IProp, StateType> {

    state = {
        curTicket: undefined,
        loadingMore: false
    };

    renderWorkflowItem(workflow: Ticket, i: number, curTicket: any) {
        let agentName = workflow.qafs.agent.name;
        let distributorName = workflow.qafs.distributor.name;
        let productName = workflow.qafs.product.code;
        let modifiedAt = new Date(workflow.modifiedAt);

        let classNameToItem = "goepik-gray-hover";

        if (curTicket != undefined && curTicket.id != undefined) {
            if (workflow.id == curTicket.id) {
                classNameToItem += " " + "goepik-ticket-active";
            }
        }

        return (
            <AppContext.Consumer key={i}>
                {({ locale, theme }) => (
                    <Row onClick={() => this.onTicketItemClicked(workflow)} className={classNameToItem}>
                        <Col sm={24} md={24} xl={24}>
                            <WorkflowItemComponent
                                name={workflow.workflow.name}
                                status={workflow.status}
                                statusLabel={workflow.statusLabel}
                                product={productName}
                                distributor={distributorName}
                                agent={agentName}
                                date={moment(modifiedAt).format(I18n.l('common.dateTimeFormat'))}
                            />
                        </Col>
                    </Row>
                )}
            </AppContext.Consumer>
        )
    }

    onTicketItemClicked(ticket: Ticket) {
        this.setState({
            curTicket: ticket
        });

        document.getElementById('ticketContentCard').scrollIntoView();
    }

    onLoadMoreClicked(loadMoreEvent: any) {
        this.startLoadingMore();

        loadMoreEvent();

        window.setTimeout(() => this.stopLoadingMore(), 2000);
    }

    startLoadingMore() {
        this.setState({
            loadingMore: true
        });
    }

    stopLoadingMore() {
        this.setState({
            loadingMore: false
        });
    }

    render(): JSX.Element {
        const {
            hasMoreWorkflowItens,
            data,
        } = this.props;

        const {
            curTicket,
        } = this.state;

        return (
            <Row id="ticketContentCard" className="goepik-component-padding">
                <Col sm={24} md={24} xl={24}>
                    {
                        (data === undefined || data.length === 0) &&
                        <Row>
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <h1>{I18n.l('titles.noDataToShow')}</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Button size={"large"} className="goepik-btn-border-main" onClick={this.props.refreshDataEvent}>
                                        {I18n.l('history.updateData')}
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    }
                    {
                        (data !== undefined) && (
                            <div>
                                {
                                    (data.length > 0) && (

                                        <Row>
                                            <Col sm={24} md={12} lg={10} xl={6}>
                                                <Row>
                                                    <Col sm={24} md={24} xl={24}>
                                                        <GoEpikCard>
                                                            <Card>
                                                                {
                                                                    (data != undefined) && data.map((data: Ticket, i: number) => {
                                                                        return (
                                                                            this.renderWorkflowItem(data, i, curTicket)
                                                                        )
                                                                    })
                                                                }
                                                                {
                                                                    (hasMoreWorkflowItens &&
                                                                        <Row className="goepik-component-padding">
                                                                            <Col sm={24} md={24} xl={24} className="goepik-see-more">
                                                                                <Button id="loadMoreBtn" size={"large"} type="primary" onClick={() => this.onLoadMoreClicked(this.props.loadMoreTickets)} loading={this.state.loadingMore}>{I18n.l('common.seeMore')}</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                }
                                                            </Card>
                                                        </GoEpikCard>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {
                                                (curTicket != undefined &&
                                                    <Col sm={24} md={16} xl={16}>

                                                        <HistoryItemHeaderComponent
                                                            detail={curTicket.workflow.name}
                                                            product={curTicket.qafs.product.code}
                                                            distributor={curTicket.qafs.distributor.name}
                                                            agent={curTicket.qafs.agent.name}
                                                            id={curTicket.id}
                                                        />
                                                        <HistoryItemComponent
                                                            registers={curTicket.registers}
                                                            ticketStatus={curTicket.status}
                                                            ticketStatusLabel={curTicket.statusLabel}
                                                        />
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    )
                                }
                            </div>
                        )
                    }
                </Col>
            </Row>
        );
    }
};

const GoEpikCard = styled.div`
    max-width: 320px;
    min-width: 260px;
    box-shadow: 1px 1px 20px ${Theme.standard.lightGray || '#e0e0e0'};

    .goepik-gray-hover:hover {
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
        cursor:pointer;
    }
    
    .goepik-ticket-active{
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
    }

    .ant-card-body{
        padding-left: 0!important;
        padding-right: 0!important;
    }

    .goepik-see-more{
        text-align: center;
        padding-bottom: 24px;
    }
`;

export default HistoryComponent;
